import React from 'react';
import env from '../../config/env';
import { GA_EVENTS, trackEvent } from '../../utils/analytics';

export default function CalendarCta({ source, className = 'btn-outline', label = 'Reservar llamada', children }) {
  if (!env.CALENDAR_URL) return null;

  return (
    <a
      href={env.CALENDAR_URL}
      target="_blank"
      rel="noreferrer"
      className={className}
      onClick={() => trackEvent(GA_EVENTS.CLICK_RESERVAR_LLAMADA, { source })}
    >
      {children}
      {label}
    </a>
  );
}
